module.exports = __webpack_public_path__ + "img/volkswagen-dostawcze.3d5850ca.png";